import request from '@/utils/request';
import { getToken } from '../utils/auth';

export interface ChatSessionCreateDTO {
  title?: string;
}

export interface ChatMessageSendDTO {
  sessionId: number;
  content: string;
}

export interface ChatSessionVO {
  id: number;
  title: string;
  isPinned: number; // 0-否，1-是
  lastMessagePreview: string;
  messageCount: number;
  createTime: string;
  updateTime: string;
}

export interface ChatMessageVO {
  id: number;
  sessionId: number;
  role: string; // 'user' | 'assistant'
  content: string;
  durationMs?: number;
  tokenUsage?: number;
  createTime: string;
}

// 创建AI对话会话
export const createChatSession = (data: ChatSessionCreateDTO) => {
  return request({
    url: '/user/chat/session',
    method: 'POST',
    data
  });
};

// 删除AI对话会话
export const deleteChatSession = (sessionId: number) => {
  return request({
    url: `/user/chat/session/${sessionId}`,
    method: 'DELETE'
  });
};

// 更新会话标题
export const updateSessionTitle = (sessionId: number, title: string) => {
  return request({
    url: `/user/chat/session/${sessionId}/title`,
    method: 'PUT',
    params: { title }
  });
};

// 切换会话置顶状态
export const toggleSessionPin = (sessionId: number) => {
  return request({
    url: `/user/chat/session/${sessionId}/pin`,
    method: 'PUT'
  });
};

// 获取会话列表
export const getChatSessions = () => {
  return request({
    url: '/user/chat/sessions',
    method: 'GET'
  });
};

// 获取会话消息历史
export const getSessionMessages = (sessionId: number) => {
  return request({
    url: `/user/chat/session/${sessionId}/messages`,
    method: 'GET'
  });
};

// 发送AI对话消息（流式）
export const sendChatMessage = (data: ChatMessageSendDTO) => {
  return request({
    url: '/user/chat/message',
    method: 'POST',
    data
  });
};